import { ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuicklinkModule } from 'ngx-quicklink';

import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../rollbar_config';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NewVersionCheckerComponent } from './new-version-checker/new-version-checker.component';
import { CheckForUpdateService } from './services/service-workers/check-for-update.service';
import { HandleUnrecoverableStateService } from './services/service-workers/handle-unrecoverable-state.service';
import { LogUpdateService } from './services/service-workers/log-update.service';
import { PromptUpdateService } from './services/service-workers/prompt-update.service';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
    declarations: [
        AppComponent
        , NewVersionCheckerComponent
    ]
    , imports: [
        BrowserModule
        , CoreModule
        , QuicklinkModule
        , ServiceWorkerModule.register(
            'ngsw-worker.js'
            , {
                enabled: true
                , registrationStrategy: 'registerWhenStable:30000'
            }
        )
    ]
    , providers: [
        CheckForUpdateService
        , LogUpdateService
        , PromptUpdateService
        , HandleUnrecoverableStateService
        , {
            provide: ErrorHandler
            , useClass: RollbarErrorHandler
        }
        , {
            provide: RollbarService
            , useFactory: rollbarFactory
        }
        , provideZoneChangeDetection()
    ]
    , bootstrap: [ AppComponent ]
})
export class AppModule {}
